import ChangePassword from "./ChangePassword/ChangePassword";
import UpdateCurrentUser from "./UpdateCurrentUser/UpdateCurrentUser";
import {
  useChangePassword,
  useUpdateUser,
  useUpdateCurrentDoctor,
  useUpdateCurrentUser,
  useGetUserById,
  useGetCurrentDoctor,
  useGetCurrentUser,
} from "./useUserQueries";

const userValues = [
  { id: "first_name", label: "Nome" },
  { id: "last_name", label: "Cognome" },
  { id: "username", label: "Username" },
  { id: "email", label: "Email" },
  { id: "mobile", label: "Cellulare" },
];
const doctorValues = [
  { id: "iban", label: "IBAN" },
  { id: "piva", label: "P. IVA" },
  { id: "date_of_birth", label: "Data di nascita" },
  { id: "address", label: "Indirizzo" },
  { id: "city", label: "Citta" },
  { id: "province", label: "Provincia" },
  { id: "cap", label: "CAP" },
  { id: "phone", label: "Telefono" },
  { id: "mobile_alert", label: "Notifiche cellulare" },
  { id: "email_alert", label: "Notifiche mail" },
];

export {
  useChangePassword,
  useUpdateUser,
  useUpdateCurrentUser,
  useUpdateCurrentDoctor,
  useGetUserById,
  useGetCurrentDoctor,
  useGetCurrentUser,
  ChangePassword,
  UpdateCurrentUser,
  doctorValues,
  userValues,
};
